import { memo } from "react"

function MeasureIndicator({ measures, count }) {
    return (
        <div className="flex items-center gap-2 justify-center">
            {Array.from({ length: measures }, (_, index) => index + 1).map((measure) => {
                const isActive = count === measure
                return (
                    <div
                        key={measure}
                        className={`${isActive ? 'bg-neutral-600' : 'bg-black'} w-1 h-1 rounded-full`}
                    />
                )
            })}
        </div>
    )
}

export default memo(MeasureIndicator)
